import React from "react";
const Notfound = () => (
  <div className="container my-lg-5 text-center text-lg-center wow fadeInUp animated">
    <h1>Page Not Found!</h1>
  </div>
);
export default Notfound;
